import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/styles';
import { withRouter } from "react-router-dom";
import  Page  from '../../components/Page';
import { NetworkContext } from '../../context/NetworkContext';
import { SnackBarContext } from "../../context/SnackbarContext";
import { useHistory } from 'react-router-dom';
import { Header, BrokerDetails } from './components';


let stateAndCity = [
  {
    name: "Tamil Nadu",
    value: "Tamil Nadu",
    city: ["Chennai","TVM","Madurai"]
  },
  {
    name: "karnataka",
    value: "karnataka",
    city: ["city1", "city2", "city3"]
  }
];

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    maxWidth: '100%',
    padding: theme.spacing(3)
  },
  results: {
    marginTop: theme.spacing(3)
  }
}));
export const EditAds = withRouter(props => {
  const history = useHistory();

  const product_id = props?.location?.pathname?.split('/')?.[2]??null;
  const classes = useStyles();
  const [productobj , setProductobj] = useState({});
  const [viewtype, setViewtype] = useState(1);
  const [masters, setMasters] = useState({
    commodity :[],
    state: []
  });
  const snackbarCtx = React.useContext(SnackBarContext);

  const { sendNetworkRequest } = React.useContext(NetworkContext);


  async function fetchmasters(){

    let commodities = await sendNetworkRequest('/admin/getparentcommodity', {}, {},false)
    let languages = await sendNetworkRequest('/admin/getactivelanguages', {}, {},false)
    let states = await sendNetworkRequest('/admin/getactivestates', {}, {},false)

    setMasters({
      ...masters,
      languages : languages.module,
      commodity : commodities.module,
      state: states.module,
    })

    let product_id = props.location.pathname.split('/')[2];
    if(product_id){
      fetchadsinfo(product_id, states.module);
    }
   
  }
  async function updateproductinfo(productdetails){

    if(productdetails.state){
      productdetails.state = productdetails.state.name;
    }
    let prodinfo = await sendNetworkRequest('/admin/addads', {}, productdetails,false)
   
    snackbarCtx.setSnack({
      ...snackbarCtx,
      open: true,
      type: prodinfo.status,
      msg: prodinfo.message,
      vertical: "top",
    });
    if(prodinfo.status == 'success')
    {
      history.push("/manageads");
    }
   
  }


  async function fetchadsinfo(prodid, stateMaster){

    let prodinfo = await sendNetworkRequest('/admin/getadsinfo', {}, {id : prodid},false)
    let language = [];
    let commodity = [];
    let parentcommodity = {}
    let subcommodity = {}
    let adscontent = {}
    let commodityobj = prodinfo?.module;
    let ads_languages = commodityobj?.ads_languages
    let ads_commodity = commodityobj?.ads_commodities

    ads_languages.map(item => {
      language.push(item.master_language);
      adscontent['name'+item?.master_language?.name] = item?.title
      adscontent['desc'+item?.master_language?.name] = item?.description
    })

    ads_commodity.map(item => {
      commodity.push(item.master_commodity);
    })
   
    let state = {};
    if(commodityobj?.state){
      
      stateMaster.map(item => {
       
        if(item.name == commodityobj?.state)
        {
        
          state = {
            ...item
          }
        }
      })
      // state = stateMaster.filter(val => val.value === commodityobj?.state)?.[0]??{};
    }
   
    let newsobj = {
          ...adscontent,
           id : commodityobj.id,
          ...commodityobj,
          adsurl : commodityobj.ads_url,
          //commodity : commodity,
          commodity : commodityobj?.parentcommodity,
          subcommodity : commodityobj?.subcommodity,
          status: prodinfo?.module?.status,
          state: state,
          language
      }
      setProductobj(newsobj)
  }


  useEffect(() => {
    fetchmasters()
  }, []);

  return (
    <Page
      className={classes.root}
      title="Broker"
    >
      <Header />
     <BrokerDetails isEdit={product_id??false} usercontent={productobj} masters={masters} viewtype={viewtype} onUpdate={updateproductinfo}/>  
     
    </Page>
  );
});

export default EditAds;
